import FailedPayment from './FailedPayment';

export default FailedPayment;
